import { takeLatest } from 'redux-saga/effects';
import { put, select, getContext } from 'redux-saga/effects';
import type { QueryClient } from 'react-query';
import {
  ROUTE_HOME,
  ROUTE_WELCOME,
  ROUTE_CAREERS,
  ROUTE_USER_REGISTER,
  ROUTE_STOCKS_HOME,
  ROUTE_PLANS,
  ROUTE_DASHBOARD,
  ROUTE_ABOUT,
} from '@/constants/routes';
import { login, logout, registration } from './routines';
import { redirect } from 'redux-first-router';
import { userOtp } from '@simplywallst/services';
import { getCurrentLocation } from '@ducks/location/selectors';
import { getAuthenticatedAhoy } from '@ducks/saga';
import { QUERY_KEY as USER_QUERY_KEY } from '@/hooks/useUser';

export function* getOTPToken() {
  try {
    const caller = getAuthenticatedAhoy();
    return yield caller(userOtp);
  } catch (e) {
    return null;
  }
}

/** sagas */

function* loginTransition(action) {
  try {
    //
    const queryClient: QueryClient = yield getContext('queryClient');
    queryClient.refetchQueries([USER_QUERY_KEY]);

    const { type: actionType } = action;
    if (actionType === login.SUCCESS) {
      const {
        tokens: { created },
      } = action.payload;
      const { type } = yield select(getCurrentLocation);
      if (
        [
          ROUTE_HOME,
          ROUTE_WELCOME,
          ROUTE_USER_REGISTER,
          ROUTE_ABOUT,
          ROUTE_CAREERS,
          ROUTE_PLANS,
        ].includes(type)
      ) {
        if (created) {
          yield put(
            redirect({
              type: ROUTE_STOCKS_HOME,
            })
          );
        } else {
          yield put(
            redirect({
              type: ROUTE_DASHBOARD,
            })
          );
        }
      }
    }
  } catch (error: any) {
    console.error('Error caught during loginTransition', {
      message: error.message,
      stack: error.stack,
    });
  }
}

export function* registrationTransition() {
  try {
    const { type } = yield select(getCurrentLocation);
    if (
      [
        ROUTE_HOME,
        ROUTE_WELCOME,
        ROUTE_USER_REGISTER,
        ROUTE_PLANS,
        ROUTE_ABOUT,
      ].includes(type)
    ) {
      yield put(redirect({ type: ROUTE_STOCKS_HOME }));
    }
  } catch (error: any) {
    console.error('Error caught during registrationTransition', {
      message: error.message,
      stack: error.stack,
    });
  }
}

export function* logoutFlowSaga() {
  try {
    // Let everyone know we're logged out now
    yield put(logout.success());
    //
    yield put(redirect({ type: ROUTE_WELCOME }));
  } catch (error: any) {
    console.error('Error caught during logoutFlowSaga', {
      message: error.message,
      stack: error.stack,
    });
  } finally {
    yield put(logout.fulfill());
  }
}

export function* redirectToWelcome() {
  try {
    console.log('️️Redirecting to /welcome');
    yield put(redirect({ type: ROUTE_WELCOME }));
  } catch (error: any) {
    console.error('Error caught during redirectToWelcome', {
      message: error.message,
      stack: error.stack,
    });
  }
}

/** watchers */

function* takeLogoutFlow() {
  yield takeLatest(logout.TRIGGER, logoutFlowSaga);
}

function* takeLoginTransition() {
  yield takeLatest([login.SUCCESS], loginTransition);
}

function* takeRegistrationTransition() {
  yield takeLatest(registration.SUCCESS, registrationTransition);
}

export const watchers = [
  takeLogoutFlow,
  takeRegistrationTransition,
  takeLoginTransition,
];
